export default __webpack_public_path__ + "static/media/xray2.12115ff0.jpg";